import { FieldDevicePhotoResolutionModel, FieldDeviceSettingsModel } from 'models';
import request, { Methods } from 'utils/request';
import { EntityService } from 'utils/entityService';
import { Mock } from 'utils/mockDecorator';

class FieldDeviceSettingsService extends EntityService {
  constructor() {
    super('field-device-settings');
  }

  @Mock(() => import('mock/fieldDeviceSettings').then((m) => m.MOCK_FIELD_DEVICE_SETTINGS))
  async getFieldDeviceSettings() {
    return request<FieldDeviceSettingsModel>({
      method: Methods.GET,
      resource: this.resource,
    });
  }

  @Mock(() => import('mock/fieldDeviceSettings').then((m) => m.MOCK_PHOTO_RESOLUTION_OPTIONS))
  async getPhotoResolutionOptions() {
    return request<FieldDevicePhotoResolutionModel[]>({
      method: Methods.GET,
      resource: `${this.resource}/photo-resolution-options`,
    });
  }

  @Mock((data: FieldDeviceSettingsModel) => data)
  async updateFieldDeviceSettings(data: FieldDeviceSettingsModel) {
    return request<FieldDeviceSettingsModel>({
      method: Methods.PUT,
      resource: this.resource,
      data,
    });
  }
}

export const fieldDeviceSettingsService = new FieldDeviceSettingsService();
